import React, { useCallback, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import connect from '../../utils/connect';
import { Context } from './OnboardingContext';

export const PlacementContext = React.createContext(null);

const PlacementProvider = ({ children }) => {
    const { currentSponsorsLists, setCurrentSponsorsList } = useContext(
        Context,
    );

    const [showPlacementUploader, setShowPlacementUploader] = useState(false);
    const [placementTypeOptions, setPlacementTypeOptions] = useState([]);
    const [placementOptions, setPlacementOptions] = useState([]);
    const [placementTypesLoading, setPlacementTypesLoading] = useState(null);
    const [isNew, setIsNew] = useState(false);
    const [placementTypeId, setPlacementTypeId] = useState(null);
    const [files, setFiles] = useState([]);
    const [prevFiles, setPrevFiles] = useState([]);
    const [rhPls, setRhPls] = useState(null);
    const [alias, setAlias] = useState('');

    const [onCustomTab, setOnCustomTab] = useState(false);
    const [newRequests, setNewRequests] = useState([]);
    const [requested, setRequested] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const [placementExampleId, setPlacementExampleId] = useState(null);
    const [reloImages, setReloImages] = useState([]);
    const [reloImagesLoading, setReloImagesLoading] = useState(true);
    const [showReloImages, setShowReloImages] = useState(false);
    const [reloImageId, setReloImageId] = useState(null);

    const [displayName, setDisplayName] = useState('');
    const [isEditingName, setIsEditingName] = useState(false);

    const addToSponsorList = useCallback(
        sp => {
            const newCurrentSponsorlist = [
                ...currentSponsorsLists,
                sp,
            ].sort((a, b) => a.name.localeCompare(b.name));
            setCurrentSponsorsList(newCurrentSponsorlist);
        },
        [currentSponsorsLists, setCurrentSponsorsList],
    );

    const providerValue = {
        showPlacementUploader,
        setShowPlacementUploader,
        placementTypeOptions,
        setPlacementTypeOptions,
        placementOptions,
        setPlacementOptions,
        placementTypesLoading,
        setPlacementTypesLoading,
        isNew,
        setIsNew,
        placementTypeId,
        setPlacementTypeId,
        files,
        setFiles,
        prevFiles,
        setPrevFiles,
        rhPls,
        setRhPls,
        alias,
        setAlias,
        onCustomTab,
        setOnCustomTab,
        newRequests,
        setNewRequests,
        requested,
        setRequested,
        showModal,
        setShowModal,
        placementExampleId,
        setPlacementExampleId,
        addToSponsorList,
        reloImages,
        setReloImages,
        reloImagesLoading,
        setReloImagesLoading,
        showReloImages,
        setShowReloImages,
        reloImageId,
        setReloImageId,
        displayName,
        setDisplayName,
        isEditingName,
        setIsEditingName,
    };

    return (
        <PlacementContext.Provider value={providerValue}>
            {children}
        </PlacementContext.Provider>
    );
};

PlacementProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default connect(['client', 'user', 'settings'])(PlacementProvider);
